import { useColorScheme } from "@ugitgud/legos/hooks/useColorScheme";
import { DistributiveOmit, WithColorScheme } from "@ugitgud/legos/ui/shared";
import { BaseButtonProps, Button } from "@ugitgud/legos/ui/form/button/Button";
import React from "react";

const schemeClasses = {
  windows: "dark:bg-accent-maroon-500 dark:hover:bg-accent-maroon-600",
  macOS: "dark:bg-accent-red-500 dark:hover:bg-accent-red-700",
  primary: "dark:bg-accent-red-500 dark:hover:bg-accent-red-700",
};

type DownloadButtonColorSchemes = keyof typeof schemeClasses;

export type DownloadButtonProps = DistributiveOmit<BaseButtonProps<"a">, "colorScheme" | "as"> &
  WithColorScheme<{}, DownloadButtonColorSchemes>;

export const DownloadButton: React.FC<DownloadButtonProps> = ({ className, colorScheme, ...rest }) => {
  const finalClasses = useColorScheme({
    classes: schemeClasses,
    default: "primary",
    scheme: colorScheme,
    className,
  });
  return <Button {...(rest as BaseButtonProps<"a">)} as="a" className={finalClasses} />;
};
